/**
 * Pick the right cover image URL by context.
 * Admin: 3 webp (thumbnailSm, thumbnailMd, thumbnailLg) + 1 SVG (image).
 * - sm: panels, thumbnails, saved books menu, orders page
 * - md: large cover on homepage
 * - lg: canvas (project page), 3D preview on checkout, canvas preview
 * - pdf: only when generating PDF - use SVG (image) for print
 *
 * @param {Object} template - selectedTemplate or { image, thumbnailSm, thumbnailMd, thumbnailLg }
 * @param {'sm'|'md'|'lg'|'pdf'} context
 * @param {string} [fallbackImagePath] - optional fallback (e.g. categoryData.details.imagePath)
 * @returns {string|null}
 */
export function getCoverImageForContext(template, context, fallbackImagePath = null) {
  if (!template) {
    return fallbackImagePath || null;
  }

  switch (context) {
    case 'pdf':
      return template.image || fallbackImagePath || null;
    case 'sm':
      return (
        template.thumbnailSm ||
        template.thumbnailMd ||
        template.thumbnailLg ||
        template.image ||
        fallbackImagePath ||
        null
      );
    case 'md':
      return (
        template.thumbnailMd ||
        template.thumbnailLg ||
        template.thumbnailSm ||
        template.image ||
        fallbackImagePath ||
        null
      );
    case 'lg':
      return (
        template.thumbnailLg ||
        template.thumbnailMd ||
        template.thumbnailSm ||
        template.image ||
        fallbackImagePath ||
        null
      );
    default:
      return (
        template.thumbnailMd ||
        template.thumbnailLg ||
        template.thumbnailSm ||
        template.image ||
        fallbackImagePath ||
        null
      );
  }
}
